"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URIHelper = void 0;
var URIHelper = /** @class */ (function () {
    function URIHelper() {
    }
    URIHelper.generate = function (baseURI, params) {
        if (params === void 0) { params = []; }
        var definitionParams = {};
        /* Identify the optionals parameters */
        params.forEach(function (param) {
            var isOptional = param.endsWith("?");
            var key = isOptional ? param.substr(0, param.length - 1) : param;
            definitionParams[key] = isOptional;
        });
        /* Return function working with the definition */
        return (function (pms) {
            /* If no pms object passed, return the boilerplate uri */
            if (!pms) {
                return Object.keys(definitionParams).reduce(function (acc, value) { return (acc + "/:" + value + (definitionParams[value] ? "?" : "")); }, baseURI);
            }
            /* Construct the uri */
            var uri = baseURI;
            for (var _i = 0, _a = Object.keys(definitionParams); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                /* If a non optional param is missing, it's an error */
                if (!definitionParams[name_1] && !pms[name_1]) {
                    throw new Error("Required parameter " + name_1 + " is missing for URI of base: \"" + baseURI + "\".");
                }
                else if (pms[name_1]) {
                    uri += "/" + pms[name_1];
                }
            }
            return uri;
        });
    };
    return URIHelper;
}());
exports.URIHelper = URIHelper;
//# sourceMappingURL=URIHelper.js.map